import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { debounce } from 'rxjs/operators';

export interface LoadingState {
  isLoading: boolean;
  activeRequests: number;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private activeRequests = 0;
  private loadingSubject = new BehaviorSubject<LoadingState>({
    isLoading: false,
    activeRequests: 0
  });

  constructor() {}

  get loadingState$(): Observable<LoadingState> {
    return this.loadingSubject.asObservable().pipe(
      debounce(state => timer(state.isLoading ? 0 : 100))
    );
  }

  get isLoading$(): Observable<boolean> {
    return new Observable(observer => {
      this.loadingState$.subscribe(state => {
        observer.next(state.isLoading);
      });
    });
  }

  get isLoading(): boolean {
    return this.loadingSubject.value.isLoading;
  }

  show(message?: string): void {
    this.activeRequests++;
    this.updateState(message);
  }

  hide(): void {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    this.updateState();
  }

  forceHide(): void {
    this.activeRequests = 0;
    this.updateState();
  }

  getActiveRequestsCount(): number {
    return this.activeRequests;
  }

  setMessage(message: string): void {
    const currentState = this.loadingSubject.value;
    this.loadingSubject.next({
      ...currentState,
      message
    });
  }

  private updateState(message?: string): void {
    const isLoading = this.activeRequests > 0;
    this.loadingSubject.next({
      isLoading,
      activeRequests: this.activeRequests,
      message: isLoading ? message : undefined
    });
  }
}